import { ReactNode, useEffect } from 'react';
import { Button, Stack, Text } from '@mantine/core';
import { openModal } from '@mantine/modals';
import { useNavigate } from 'react-router-dom';
import { setAuthHandlers } from '../api/client.tsx';

export function AuthProvider({ children }: { children: ReactNode }) {
  const navigate = useNavigate();

  const promptLogin = () => {
    openModal({
      title: '登入失效',
      withCloseButton: false,
      closeOnClickOutside: false,
      closeOnEscape: false,
      children: (
        <Stack>
          <Text size="sm">登入狀態已失效，請重新登入。</Text>
          <Button
            onClick={() => {
              window.location.href = `${import.meta.env.VITE_BASE_URL}/maas_billing_accounting_entries`;
            }}
          >
            前往登入
          </Button>
        </Stack>
      ),
    });
  };

  useEffect(() => {
    setAuthHandlers({
      promptLogin,
      goForbidden: () => navigate('/forbidden'),
    });
  }, [navigate]);

  return <>{children}</>;
}
